import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import StockOutTransfer from "./StockOutTransfer";
import StockOutManual from "./StockOutManual";
import StockOutHistory from "./StockOutHistory";
import StockOutSale from "./StockOutSale";

const validTabs = ["penjualan", "transfer", "manual", "riwayat"];

export default function StockOutPage() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get("tab");
  const hasInventoryTransferItems =
    Array.isArray(location.state?.inventoryTransferItems) &&
    location.state.inventoryTransferItems.length > 0;
  const [tab, setTabState] = useState(
    hasInventoryTransferItems
      ? "transfer"
      : (validTabs.includes(requestedTab) ? requestedTab : "penjualan")
  );

  useEffect(() => {
    if (hasInventoryTransferItems) {
      setTabState("transfer");
      return;
    }
    const requested = searchParams.get("tab");
    if (validTabs.includes(requested)) setTabState(requested);
  }, [hasInventoryTransferItems, searchParams]);

  const setTab = (value) => {
    if (!validTabs.includes(value)) return;
    setTabState(value);
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set("tab", value);
      return next;
    }, { replace: true });
  };
  const items = [
    ["penjualan", "Penjualan"],
    ["transfer", "Transfer"],
    ["manual", "Manual"],
    ["riwayat", "Riwayat"],
  ];

  return (
    <div className="space-y-4">
      <div data-workspace-redundant-header><h1 className="text-2xl font-semibold">Stock Out</h1></div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-global-nav-layer="2" className="h-9 w-full gap-1 flex-nowrap">
          {items.map(([value, label]) => (
            <TabsTrigger key={value} value={value}>{label}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="penjualan"><StockOutSale /></TabsContent>
        <TabsContent value="transfer"><StockOutTransfer /></TabsContent>
        <TabsContent value="manual"><StockOutManual /></TabsContent>
        <TabsContent value="riwayat"><StockOutHistory /></TabsContent>
      </Tabs>
    </div>
  );
}

function Panel({ title }) {
  return (
    <div className="rounded-lg border bg-white p-6">
      <h2 className="font-semibold">{title}</h2>
      <p className="mt-2 text-sm text-slate-500">
        Kerangka awal. Penyimpanan akan diaktifkan setelah integrasi stok dan keuangan aman.
      </p>
    </div>
  );
}
